import { useEffect, useState } from 'react';

import Spinner from '../../../reusable/spinner/spinner.component';
import Client from '../../../../tools/client';

import BackgroundConfigurationDisplay from './background/background-configuration-display.component';
import CMSConfigurationDisplay from './cms/cms-configuration-display.component';
import CompanyConfigurationDisplay from './company/company-configuration-display.component';
import FooterConfigurationDisplay from '../app/footer/footer-configuration-display.component';
import MaintenanceConfigurationDisplay from './maintenance/maintenance-configuration-display.component';
import ThemeConfigurationDisplay from './theme/theme-configuration-display.component';

import {
  Container,
  FieldSection,
  FieldGroup,
  Label,
  Input,
  ButtonRow,
  Button,
  SectionTitle
} from '../configuration-sections.styles';

const client = new Client();

const AppConfigurationDisplay = () => {
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState('');

  useEffect(() => {
    const fetchConfig = async () => {
      const res = await client.setup();
      const app = res.configuration?.app || {};
      setName(app.name || '');
      setLoading(false);
    };
    fetchConfig();
  }, []);

  const handleSave = async () => {
    await client.updateConfigurationByKey('app.name', { value: name });
    setEditing(false);
  };

  if (loading) return <Spinner />;

  return (
    <Container>
      <FieldSection>
        <SectionTitle>App</SectionTitle>

        <FieldGroup>
          <Label htmlFor="appName">App Name</Label>
          <Input
            name="appName"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={!editing}
          />
        </FieldGroup>

        <ButtonRow>
          {editing ? (
            <>
              <Button onClick={() => setEditing(false)}>Cancel</Button>
              <Button primary onClick={handleSave}>Save</Button>
            </>
          ) : (
            <Button primary onClick={() => setEditing(true)}>Edit</Button>
          )}
        </ButtonRow>
      </FieldSection>

      <FieldSection>
        <SectionTitle>Footer</SectionTitle>
        <FooterConfigurationDisplay />
      </FieldSection>

      {/* TODO - add back in with Theme update */}
      {/* <FieldSection>
        <SectionTitle>Theme Settings</SectionTitle>
        <ThemeConfigurationDisplay />
      </FieldSection> */}

      <FieldSection>
        <SectionTitle>CMS Settings</SectionTitle>
        <CMSConfigurationDisplay />
      </FieldSection>

      <FieldSection>
        <SectionTitle>Company Settings</SectionTitle>
        <CompanyConfigurationDisplay />
      </FieldSection>

      {/* TODO - add back in with Theme update */}
      {/* <FieldSection>
        <SectionTitle>Background Settings</SectionTitle>
        <BackgroundConfigurationDisplay />
      </FieldSection> */}

      <FieldSection>
        <SectionTitle>Maintenance Settings</SectionTitle>
        <MaintenanceConfigurationDisplay />
      </FieldSection>
    </Container>
  );
};

export default AppConfigurationDisplay;